import React, { PureComponent } from 'react';

import { createContainer } from '@dbk-legacy/muster/react';
import BlurModal from '../../common/blur-modal';
import { PdfContent } from '../../../screens/modal-content';
import { EBANKINGWEBLUX, EBANKINGWEBUK, FSCS_LOGO_URL, RM_REGION_UK, RM_ACCESS, ROUTES } from '../../../../src/constants';
import  envConfig from '../../../../db-env-build';
import FSCSLogo from '../../../assets/svgs/Fscs-logo';

class AppFooter extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      doneVisible: true,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.toggleModalDone = this.toggleModalDone.bind(this);
  }

  toggleModal(pageType) {
    this.setState({
      modal: !this.state.modal,
      modalContentType: pageType,
    });
  }

  toggleModalDone(displayModalDone) {
    this.setState({
      doneVisible: displayModalDone,
    });
  }


  modalContent() {
    const { modalContentType } = this.state;

    switch (modalContentType) {
      case 'faq':
        return <PdfContent modalContentType="faq" />;
      case 'security':
        return <PdfContent modalContentType="security" />;
      case 'userManual':
        return <PdfContent modalContentType="userManual" />;
      default:
        return <div />;
    }
  }

  render() {
    const { i18n: { messages }, changePage, languages: { destLanguage }, rmAccess: { userAdminGroup } } = this.props;
    let headerTitle = '';
    switch (this.state.modalContentType) {
      case 'faq': headerTitle = messages['app.login.faq'];
        break;
      case 'security': headerTitle = messages['app.login.securityTips'];
        break;
      case 'userManual': headerTitle = messages['app.login.userManual'];
        break;
      default: headerTitle = '';
        break;
    }
    let className = 'fscsText fscsLogo';
    if (destLanguage === "Deutsch") {
      className += ' fscsLogoGerman';
    }
    return (
      <div className="app-footer show-for-large ">
          <div className="columns">
            <div
              id={messages['app.common.copyrightText']}
              className="copyright-text"
            >
              {' '}
              {messages['app.common.copyrightText']}{' '}
            </div>
            <span className="pipe"> | </span>
            <div
              id={messages['app.common.copyrightDisclaimer']}
              className="copyright-disclaimer-text"
            >
              {' '}
              {messages['app.common.copyrightDisclaimer']}{' '}
            </div>
          { (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) &&
            <div className={className} >
              <span className="pipe"> | </span>
              <span className='logoPosition'>
                <a rel="noopener" href={FSCS_LOGO_URL} target="_blank" >
                  <FSCSLogo />
                  <span className='logoText'>{messages['app.payment.fscsLogo.text']}</span>
                </a>
              </span>
            </div>
          }
            <div className="faq-security-tips">
              <div>
                <span className="pipe"> | </span>
                  <a
                    className="cursor"
                    id="User Manual"
                    onClick={() => this.toggleModal('userManual')}
                  >
                  {messages['app.login.userManual']}
                  </a>
                </div>
              <span className="pipe"> | </span>
              <a
                className="cursor"
                id="FAQ"
                onClick={ userAdminGroup === RM_ACCESS.RM_DOC_UPLOAD ? () => this.props.changePage(ROUTES.RMACCESS.DOC_TAB_CONTAINER_FAQ) : () => this.props.changePage('/login-faq')}
              >
                {messages['app.login.faq']}
              </a>
              <span className="pipe"> | </span>
              <a
                className="cursor"
                id="SecurityTips"
                onClick={ userAdminGroup === RM_ACCESS.RM_DOC_UPLOAD ? () => this.props.changePage(ROUTES.RMACCESS.DOC_TAB_CONTAINER_SEQURITY) : () => this.props.changePage('/login-security')}
              >
                {messages['app.login.securityTips']}
              </a>
            </div>
          </div>

        {this.state.modal &&
          <BlurModal
            onDone={this.toggleModal}
            visible={this.state.modal}
            headerChildren={headerTitle}
            doneVisible={this.state.doneVisible}
            size="large"
          >
            {this.modalContent()}
          </BlurModal>
        }
      </div>
    );
  }
}

export default createContainer(
  {
    $queries: {
      changePage: { $call: 'ui.history.push' },

      i18n: {
        messages: true,
      },
      languages: {
        destLanguage: true
      },
      rmAccess: {
        userAdminGroup: true
      }
    },
  },
  ({ ui, ...queries }) => ({
    ...queries,
  })
)(AppFooter);
